export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">关于UU</h2>
          <p className="text-sm text-foreground-500">了解UU漫画的初心与使命</p>
        </div>
        <div className="max-w-[800px] mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-10">
            <div className="flex flex-col md:flex-row items-start gap-6 md:gap-10">
              <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-50 flex items-center justify-center">
                <i className="ri-book-read-line text-3xl md:text-4xl text-primary-500"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-4">UU漫画 — 让每一位漫迷都能免费畅读</h3>
                <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                  <p>
                    UU漫画创立于对漫画的热爱，我们相信每一位漫迷都应享有<strong>免费漫画全集</strong>的阅读权利。作为国内领先的<strong>免费漫画大全</strong>平台，我们汇集了来自全球的海量漫画资源，从热血战斗到甜蜜恋爱，从悬疑推理到奇幻冒险，数十种题材、上万部作品，全部向用户免费开放。
                  </p>
                  <p>
                    我们坚持<strong>全集免费看</strong>的理念，无会员门槛、无隐藏收费，真正实现每一部<strong>免费完整版漫画</strong>都能从头看到尾。平台每日同步更新最新连载，确保读者第一时间追更心仪作品。
                  </p>
                  <p>
                    用心做好<strong>在线免费阅读</strong>体验是UU漫画始终不变的追求。从高清画质到流畅加载，从多端适配到夜间模式，每一个细节都凝聚着团队对<strong>免费漫画资源</strong>品质的执着。感谢每一位漫迷的陪伴与支持，我们将继续努力，让漫画的世界更加精彩。
                  </p>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-6 pt-6 border-t border-background-200/60">
                  <div className="flex items-center gap-2 text-sm">
                    <i className="ri-user-smile-line text-primary-500 text-lg"></i>
                    <span className="text-foreground-500">服务漫迷</span>
                    <span className="font-bold text-primary-500">500万+</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <i className="ri-calendar-check-line text-accent-500 text-lg"></i>
                    <span className="text-foreground-500">稳定运营</span>
                    <span className="font-bold text-accent-500">5年+</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <i className="ri-thumb-up-line text-secondary-500 text-lg"></i>
                    <span className="text-foreground-500">好评率</span>
                    <span className="font-bold text-secondary-500">98.7%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}